import { inject, Pipe, PipeTransform } from "@angular/core";
import { MaskingStore } from "../stores/masking.store";

/**
 * 전화번호 마스킹 파이프
 * 예: 01012345678 → 010-****-5678
 */
@Pipe({
    name: "maskPhone",
    standalone: true,
    pure: false,
})
export class MaskPhonePipe implements PipeTransform {
    private store = inject(MaskingStore);

    transform(value: string | null | undefined): string {
        if (!this.store.isMaskingEnabled()) {
            return value || "-";
        }

        if (!value) return "-";

        const cleaned = value.replace(/[^0-9]/g, "");

        if (cleaned.length === 11) {
            // 010-****-1234
            return `${cleaned.slice(0, 3)}-****-${cleaned.slice(7)}`;
        } else if (cleaned.length === 10) {
            // 02-****-1234 또는 031-***-1234
            if (cleaned.startsWith("02")) {
                return `${cleaned.slice(0, 2)}-****-${cleaned.slice(6)}`;
            }
            return `${cleaned.slice(0, 3)}-***-${cleaned.slice(6)}`;
        }

        // 기타 포맷
        return value.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-****-$3");
    }
}
